import React, { Suspense } from 'react'
import ColorBox from 'common/Box/ColorWhiteBox'
import PageLayoutV2 from 'common/Layout/Page/PageLayoutV2'
import LayoutSkeleton from 'common/Skeletons/LayoutSkeleton'

const AllCatalog = React.lazy(() => import('./AllCatalog'))
function FaberCatalogueDashboard() {
  return (
    <Suspense fallback={<LayoutSkeleton />}>
      <PageLayoutV2 header='Manage Catalogue'>
        <ColorBox sx={{ minWidth: '1000px' }}>
          <AllCatalog />
        </ColorBox>
      </PageLayoutV2>
    </Suspense>
  )
}

export default FaberCatalogueDashboard
